import { cn } from '@/lib/utils';
import { useEchoHireTheme } from '@/theme/ThemeProvider';

/** Logos: place `echoLogoDark.png` and `echoLogoLight.png` in `/public`. */
export default function EchoHireLogo({ collapsed = false, className, size = 'default' }) {
  const { resolvedMode } = useEchoHireTheme();
  const src = resolvedMode === 'dark' ? '/echoLogoDark.png' : '/echoLogoLight.png';

  const bySize = {
    default: collapsed
      ? 'mx-auto h-11 max-h-11 w-auto max-w-[3.5rem]'
      : 'h-12 max-h-12 max-w-[13rem] object-left sm:max-w-[14rem]',
    compact: collapsed
      ? 'mx-auto h-8 max-h-8 w-auto max-w-[2.75rem]'
      : 'h-9 max-h-9 w-auto max-w-[9.5rem] object-left',
    prominent: collapsed
      ? 'mx-auto h-12 max-h-12 max-w-[3.75rem]'
      : 'h-16 max-h-16 max-w-[min(100%,20rem)] object-left sm:h-[4.5rem] sm:max-h-[4.5rem] sm:max-w-[22rem]',
  };

  return (
    <img
      src={src}
      alt="EchoHire"
      className={cn('w-auto select-none object-contain', bySize[size] || bySize.default, className)}
      draggable={false}
    />
  );
}
